import { DeliveryNoteParams } from '../../models';

export class DeliveryNotePartiesLoad {
  public static readonly type = '[DeliveryNoteParties] Load Parties';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNotePartiesInitialState {
  public static readonly type = '[DeliveryNoteParties] Set Initial State';
}
